import React, { useEffect } from "react";
import styles from "../assets/scss/pages.module.scss";
import Title from "components/title/Title";
import GalleriesDescriptionSection from "sections/galleriesPage/galleriesDescriptionSection/GalleriesDescriptionSection";
import GalleriesListSection from "sections/galleriesPage/galleriesListSection/GalleriesListSection";
import BigGalleryCard from "components/cards/bigGalleryCard/BigGalleryCard";

const GalleriesPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.galleriesPageContainer}>
      <div className="container">
        <Title text={"Galleries"} bottomStrokeWidth={"55%"} />
        <GalleriesDescriptionSection />
        <GalleriesListSection />
        <div className={styles.galleriesList}>
          <BigGalleryCard />
          <BigGalleryCard />
          <BigGalleryCard />
        </div>
        <div className={styles.loadMore}>
          <button>Load More</button>
        </div>
      </div>
    </div>
  );
};

export default GalleriesPage;
